module.exports = __webpack_public_path__ + "static/media/homeowner1-1.397636c8.png";